import { Inject, Pipe, PipeTransform } from '@angular/core';
import { GA4 } from '../models/ga4.model';
import { GA4_ITEMS_MAPPER } from '../tokens';

@Pipe({
    name: 'mapGA4Items',
})
export class MapGA4ItemsPipe implements PipeTransform {

    constructor(
        @Inject(GA4_ITEMS_MAPPER) private ga4ItemsMapper: (...args) => Array<Omit<GA4.Item, '__event_name'>>
    ) {}

    transform(args): Array<Omit<GA4.Item, '__event_name'>> {
        return this.ga4ItemsMapper(args);
    }

}
